import React, { ChangeEvent, useCallback } from "react";
import UnitTextField from "../../../../components/UnitTextField";
import CoilCalculator, { getSpecificWeight } from "../CoilCalculator";
import { LENGTH_M, roundToDigits } from "../../../../util/numberFormat";
import { Theme, WithStyles, createStyles, withStyles } from "@material-ui/core";
import { TextFieldProps } from "@material-ui/core/TextField";
import { InputLabelProps as InputLabelPropsType } from "@material-ui/core/InputLabel";
import cx from "classnames";

const styles = (theme: Theme) =>
  createStyles({
    root: {
      display: "flex",
      flex: 1,
      minWidth: 170,
      alignItems: "center",
    },
    calculator: {
      marginLeft: theme.spacing.unit,
    },
  });

function CoilStockInputField({
  classes,
  className,
  value,
  onChange,
  label,
  autoFocus,
  unit,
  inputRef,
  article,
  method,
  variant = "filled",
  margin = "dense",
  InputLabelProps,
}: {
  className?: string;
  value: string;
  onChange: (
    amount: number | string,
    event?: ChangeEvent<
      HTMLTextAreaElement | HTMLInputElement | HTMLSelectElement
    >,
  ) => void;
  label: string;
  autoFocus?: boolean;
  unit: string;
  inputRef: any;
  method: "unit" | "weight";
  article: any;
  variant?: TextFieldProps["variant"];
  margin?: TextFieldProps["margin"];
  InputLabelProps?: InputLabelPropsType;
} & WithStyles<typeof styles>) {
  const handleChange = useCallback(
    (
      e: ChangeEvent<
        HTMLTextAreaElement | HTMLInputElement | HTMLSelectElement
      >,
    ) => {
      onChange(e.target.value, e);
    },
    [onChange],
  );

  const handleSubmit = useCallback(
    ({ length }: { length: number }) => {
      onChange(roundToDigits(length / 1000, LENGTH_M));
    },
    [onChange],
  );

  return (
    <div className={cx(classes.root, className)}>
      <UnitTextField
        label={label}
        autoFocus={autoFocus}
        unit={unit}
        value={value ?? ""}
        onChange={handleChange}
        margin={margin}
        variant={variant}
        fullWidth
        type="number"
        InputLabelProps={InputLabelProps}
        inputRef={inputRef}
      />
      {method === "unit" && (
        <CoilCalculator
          ButtonProps={{ className: classes.calculator }}
          defaultWidth={article.coil?.width ?? article.details?.width}
          defaultThickness={
            article.coil?.thickness ?? article.details?.thickness
          }
          defaultSpecificWeight={(
            getSpecificWeight(
              article.coil?.material ?? article.details?.matertial ?? "",
            ) ?? 7.85
          ).toString()}
          onSubmit={handleSubmit}
        />
      )}
    </div>
  );
}

export default withStyles(styles)(CoilStockInputField);
